import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {

  private readonly LicenseRequired: string = 'license_required';

  private readonly InvalidPlatform: string = 'invalid platform';

  constructor(
    private injector: Injector
  ) { }

  private logError(msg: string): void {
    console.error(msg);
  }

  handleError(error: Error | HttpErrorResponse) {
    const router = this.injector.get(Router);
    if (error instanceof HttpErrorResponse) {
      if (!navigator.onLine) {
        this.logError('No Internet Connection');
      } else if (this.notAuthorised(error)) {
        this.logError('User not authorised');
        router.navigate(['/']);
      } else if (this.unauthorisedPlatform(error)) {
        this.logError('Invalid Platform');
        router.navigate(['/invalid-platform']);
      } else if (this.notLicensedForProduct(error)) {
        this.logError('Not licensed for product');
        router.navigate(['/not-licensed']);
      }
    }
    // Log the error
    console.error(error);

    /**
     *  Http Errors should currently be rethrown to allow error effects to trigger, other errors have no handling and should not be suppressed so are thrown here.
     */
    throw error;

  }

  private hasErrorMessage(error: HttpErrorResponse, message: string): boolean {
    return error.error &&
      (( error.error == message) ||
      error.error.hasOwnProperty('Message') &&
      error.error.Message === message);
  }


  /**
   * User is not authorised
   * @param error
   */
  private notAuthorised(error: HttpErrorResponse): boolean {
    return error.status === 401;
  }

  /**
   * A call was made to an Api for a product that the user or installation is not licensed for
   * @param error
   */
  private notLicensedForProduct(error: HttpErrorResponse): boolean {
    return error.status === 403 && this.hasErrorMessage(error, this.LicenseRequired);
  }

  /**
   * A call was made to an api for a platform that the user is not authorised for
   * @param error
   */
  private unauthorisedPlatform(error: HttpErrorResponse): boolean {
    return error.status === 403 && this.hasErrorMessage(error, this.InvalidPlatform);
  }
}
